// extracted by mini-css-extract-plugin
export default {"actionButton":"Ir21InboxTable_actionButton__mVFu4"};